import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useEffect, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit, FaEye } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import PriceBooksModalContent from "./ModalContent/PriceBooksModalContent";
import { useNavigate } from "react-router-dom";
import { useGetALlPriceBook } from "./usePriceBook";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useGetOrgUnitsData } from "../Employee/hooks/useEmployee";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";




const HeaderContent = (props: any) => {

  const handleFilter = (key: any, selected: any) => {
    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));

  };

  return (
    <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={props?.orgUnitsList || []}
        onSelect={(e) => handleFilter(props.handleFilterObjectKey, e)}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading={props?.DropdownHeading}
        headingColor="#2e8dd3"
      />
    </div>
  );
};




const Pricebooks = () => {
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inputSearch,setInputSearach] = useState<string>('')
  const [row,setRow] = useState<any>('');
  
  const [chechStatusSubmitAndUpdate,setchechStatusSubmitAndUpdate] = useState<string>('')
  const [filterState,setFilterState] = useState<any>({
    search:'',
    page:1,
    orgUnit:null,
    limit:10
  })

  const [disable ,setDisabled] = useState(false);
   useEffect(()=>{ 
      const delayDebounce = setTimeout(()=>{
        if(inputSearch.trim() !== ''){
          setFilterState((prev:any)=>({
           ...prev,
           page:inputSearch
          }))
        }
      },5000)

      return ()=>clearTimeout(delayDebounce);
   },[inputSearch])

  const navigate = useNavigate(); // ✅ Fix for "Cannot find name 'navigate'"
  const handleManageClick = (brand: any) => {
    navigate(`/catalogue/pricebooks/pricebookbydiv`, { state: { brand } }); // ✅ Fix for "Cannot find name 'handleManageClick'"
  };

  const priceBooksDataColumns = (handleEdit:(row:any,status:string)=>void)=> [
    {
      name: "Pricebook Name",
      selector: (row: { pricebookname: number | string }) => row.pricebookname,
      sortable: true,
      wrap:true,
      // maxWidth:'200px'
      
    },
    {
      name: "Description",
      selector: (row: { description: string }) => row.description,
      sortable: true,
      wrap:true,
      // maxWidth:'200px'
    },
    {
      name: "Org Unit Name",
      selector: (row: { orgunit: string }) => row.orgunit,
      sortable: true,
      
    },
    {
      name: "Created At",
      selector: (row: { Created_on: string }) => row.Created_on,
      sortable: true,
      width:'250px'
      
    },
    {
      name: "Action",
      cell: (row: any) => (

        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
            onClick={()=>handleEdit(row,'update')}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} />
            Edit
          </button>

          <button
            onClick={() => handleManageClick(row)}
            className="btn d-flex align-items-center justify-content-center gap-1"
            style={{
              backgroundColor: "#2e8dd3",
              color: "white",
              borderRadius: "20px",
              padding: "3px",
              width: "70px",
              border: "none",
            }}
          >
            <FaEye size={14} style={{ fill: "#fff" }} /> View
          </button>
        </div>
        
      ),
    },
  ];
 
   // api
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
   const {data,isSuccess,isLoading} = useGetALlPriceBook({enable:true,
    params:{
    orgUnitId:filterState.orgUnit,
   ...(filterState?.search ==""?{}:{search:filterState?.search}),
    // search:filterState?.search,
    page:filterState?.page,
    limit:filterState?.limit,
   }})
   const PriceBookData = data?.data?.data.map((item:any)=>({
            id:item?.PricebookId,
            OrgId:item?.OrgId,
            pricebookname:item?.PricebookName,
            description:item.PricebookDescription ,
            orgunit:item?.OrgUnit?.UnitName,
            Created_on:item?.OrgUnit?.CreatedAt.split('.')[0]|| '-',
   }))
      
  const handlePagination =(pageNo:number)=>{
       setFilterState((prev:any)=>(
        {
          ...prev,
          page:pageNo
        }
       ))
  }

  const handleRowPerPage =(limit:any,pageNo:any)=>{
   setFilterState((prev:any)=>({
        ...prev,
          page:pageNo,
          limit:limit
   }))
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  };
  const handleClose = () =>{
    setchechStatusSubmitAndUpdate(''); 
    setIsModalOpen(false)};
   
  const handleEdit = (row:any,status:string)=>{
    setchechStatusSubmitAndUpdate(status);  
    setRow(row);
    setIsModalOpen(true);
  }
 
  const handleDownload = async(fileType:string)=>{
        const appToken = localStorage.getItem('Apptoken') ||'';
        const priceBookId = null;
        const params:Record<string,any> ={
         ...(priceBookId === null ? {}:{priceBookId:priceBookId}),
         ...(filterState.orgUnit === null ? {}:{orgUnitId:filterState.orgUnit}),
         ...(filterState.search === '' ?{}:{search:filterState.search}) 
        }

        const queryString = new URLSearchParams(params).toString();
        const apiEndpoint = `${BASE_URL}admin/api/getPriceBookExcel?${queryString}`;
        const fileName = 'PriceBook.xlsx';

        try{
          setDisabled(true);
          const response = await  downloadExcelGet({apiEndpoint,appToken,fileName})

          if(response.success){
            setDisabled(false);
          }

        }catch(error:any){
           console.log("Error Wile downloading Excel")
        }finally{
          setDisabled(false);
        }
  }

  return (
    <div className="p-2">
      <PageHeader
        title="Pricebooks"
        buttons={[
          {
            label: "+ Add Pricebook",
            onClick:() => {
              toggleModal(); 
              setchechStatusSubmitAndUpdate('Add')
            },
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => handleDownload('Excel'),
            color: disable ? "#888": "#43B9B2",
            disable:disable
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        search={true}
        dynamicHeightOnRowsPerPage={true}
        // handleSearch={(e:any)=>setInputSearach(e)}
        handleSearch={(e:any)=>setFilterState((prev:any)=>({
          ...prev,
          search:e
        }))}
        Title="PriceBook Lists"
        showSpinner={isLoading}
        data={!isLoading && isSuccess && PriceBookData || []}
        columns={priceBooksDataColumns(handleEdit)}
        paginationTotalRows={data?.data?.pagination?.total_records} 
        onChangePage={(pageNo:number)=>handlePagination(pageNo)}
        onChangeRowsPerPage={(limit:any,pageNo:any)=>handleRowPerPage(limit,pageNo)}
        headerContent={
          <div style={{marginRight:10}}>
         <HeaderContent
         orgUnitsList={orgUnitsList?.data} 
         setFiltersState={setFilterState}
         DropdownHeading="Org Unit"
         handleFilterObjectKey ="orgUnit"
         />
         </div>
       }

     />
      <RouteModal
        isOpen={isModalOpen}
        title= {chechStatusSubmitAndUpdate ==='update'?'Edit PriceBook' :"Add Price Books"}
        size="md"
        content={<PriceBooksModalContent handleClose={handleClose} priceBookRow={row}  chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}  />}
/>
    </div>
  );
};

export default Pricebooks;
